export { default } from "./ProtectedRoute.container";
